





































































































import { Component, Prop, Vue } from "vue-property-decorator";
import MonitoringKritisIgdTtvDialog from "./MonitoringKritisIgdTtvDialog.vue";
import MonitoringKritisIgdSvc from "@/services/MonitoringKritisIgdService";
import { appModule } from "@/store/modules/app";
import moment from "moment";

@Component({
  components: { MonitoringKritisIgdTtvDialog }
})
export default class MonitoringKritisIgdTtvTimeline extends Vue {
  @Prop() monitoring!: any;
  @Prop({ default: false }) readonly!: boolean;

  showTtvDialog = false;
  editingTtv: any = null;
  countdownText = "";
  countdownTimer: any = null;

  ttvHeaders = [
    { text: "Tanggal & Jam", value: "waktu", width: "95px" },
    { text: "Min", value: "menit_ke", width: "50px" },
    { text: "TD", value: "td_formatted", width: "80px" },
    { text: "MAP", value: "map", width: "60px" },
    { text: "Nadi", value: "nadi", width: "60px" },
    { text: "RR", value: "respirasi", width: "50px" },
    { text: "Suhu", value: "suhu", width: "60px" },
    { text: "SpO2", value: "spo2", width: "60px" },
    { text: "O2", value: "o2_support", width: "70px" },
    { text: "GCS", value: "gcs_total", width: "50px" },
    { text: "EWSS", value: "ewss", width: "70px", sortable: false },
    { text: "I/O (mL)", value: "io_cairan", width: "110px", sortable: false },
    { text: "Perawat", value: "perawat_nama", width: "90px", sortable: false },
    { text: "", value: "actions", width: "70px", sortable: false },
  ];

  mounted() {
    this.startCountdown();
  }

  beforeDestroy() {
    if (this.countdownTimer) clearInterval(this.countdownTimer);
  }

  get sortedTtvs() {
    return [...(this.monitoring?.ttvs || [])].sort(
      (a: any, b: any) => new Date(a.waktu).getTime() - new Date(b.waktu).getTime()
    );
  }

  get targetAlert() {
    const targets = this.monitoring?.resuscitation_targets;
    const latest = this.sortedTtvs[this.sortedTtvs.length - 1];
    if (!targets || !latest) return null;
    const alerts: string[] = [];
    if (targets.target_map && latest.map && latest.map < targets.target_map) {
      alerts.push(`MAP ${latest.map} < target ${targets.target_map}`);
    }
    if (targets.target_spo2 && latest.spo2 < targets.target_spo2) {
      alerts.push(`SpO2 ${latest.spo2}% < target ${targets.target_spo2}%`);
    }
    return alerts.length > 0 ? alerts.join(" | ") : null;
  }

  ttvTrend(field: string): number[] {
    return this.sortedTtvs
      .filter((t: any) => t[field] !== null && t[field] !== undefined)
      .map((t: any) => t[field]);
  }

  ewssColor(kategori: string) {
    const colors: Record<string, string> = {
      normal: "green", ringan: "green", sedang: "amber darken-2", tinggi: "red", blue: "blue",
    };
    return colors[kategori] || "grey";
  }

  formatTime(waktu: string) {
    return waktu ? moment(waktu).format("HH:mm") : "-";
  }

  formatDate(waktu: string) {
    return waktu ? moment(waktu).format("DD/MM/YYYY") : "";
  }

  // IGD-024: ringkas Input/Output cairan per pengukuran ("In 700 / Out 300").
  ioSummary(item: any) {
    const intake = (item.intake_oral_ngt_ml || 0) + (item.intake_parenteral_ml || 0);
    const output = (item.urine_output_ml || 0) + (item.output_muntah_ml || 0) + (item.output_drain_ml || 0);
    if (!intake && !output) return "-";
    return `In ${intake} / Out ${output}`;
  }

  ioTooltip(item: any) {
    const parts: string[] = [];
    if (item.intake_oral_ngt_ml) parts.push(`Oral/NGT ${item.intake_oral_ngt_ml}`);
    if (item.intake_parenteral_ml) parts.push(`Parenteral ${item.intake_parenteral_ml}${item.intake_parenteral_jenis ? " (" + item.intake_parenteral_jenis + ")" : ""}`);
    if (item.urine_output_ml) parts.push(`Urine ${item.urine_output_ml}`);
    if (item.output_muntah_ml) parts.push(`Muntah/NGT ${item.output_muntah_ml}`);
    if (item.output_drain_ml) parts.push(`Drain ${item.output_drain_ml}`);
    return parts.join(" · ");
  }

  tambahTtv() {
    this.editingTtv = null;
    this.showTtvDialog = true;
  }

  editTtv(item: any) {
    this.editingTtv = item;
    this.showTtvDialog = true;
  }

  async hapusTtv(item: any) {
    if (!confirm("Hapus data TTV ini?")) return;
    try {
      const resp = await MonitoringKritisIgdSvc.deleteTtv(this.monitoring.id, item.id);
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("TTV dihapus");
        this.$emit("saved");
      }
    } catch { /* handled */ }
  }

  onTtvSaved() {
    this.showTtvDialog = false;
    this.editingTtv = null;
    this.$emit("saved");
  }

  startCountdown() {
    if (this.monitoring?.disposisi_at) return;
    const threshold = this.monitoring?.triage_level === "P1" ? 5 : 15;
    this.countdownTimer = setInterval(() => {
      const latest = this.sortedTtvs[this.sortedTtvs.length - 1];
      if (!latest) {
        this.countdownText = "Belum ada TTV";
        return;
      }
      const lastTime = new Date(latest.waktu).getTime();
      const nextDue = lastTime + threshold * 60000;
      const remaining = Math.max(0, Math.floor((nextDue - Date.now()) / 1000));
      const m = Math.floor(remaining / 60);
      const s = remaining % 60;
      this.countdownText = `${m}:${s.toString().padStart(2, "0")}`;
    }, 1000);
  }
}
